module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [(_vm.props) ? _c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__logo"
  }, [_c('div', {
    staticClass: "footer__logo--1",
    style: ({
      backgroundImage: "url(" + _vm.props.acf.footer.logos[0].url + ")"
    })
  })]), _c('div', {
    staticClass: "footer__locations"
  }, _vm._l((_vm.props.acf.footer.locations), function(place) {
    return _c('div', {
      staticClass: "footer__location"
    }, [_c('div', {
      staticClass: "footer__title",
      domProps: {
        "innerHTML": _vm._s(place.location)
      }
    }), _c('div', {
      staticClass: "footer__address"
    }, [_c('a', {
      staticClass: "footer__address--link",
      attrs: {
        "href": place.maps_link,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(place.address)
      }
    })]), _c('div', {
      staticClass: "footer__phone"
    }, [_c('a', {
      staticClass: "footer__phone--link",
      attrs: {
        "href": place.phone_link
      },
      domProps: {
        "innerHTML": _vm._s(place.phone_number)
      }
    })]), _c('a', {
      staticClass: "footer__email",
      attrs: {
        "href": "mailto:" + place.email
      },
      domProps: {
        "innerHTML": _vm._s(place.email)
      }
    })])
  })), _c('div', {
    staticClass: "footer__logo"
  }, [_c('div', {
    staticClass: "footer__logo--2",
    style: ({
      backgroundImage: "url(" + _vm.props.acf.footer.logos[1].url + ")"
    })
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c69ae4a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 529
// module chunks = 1